export default class DateInput {
    constructor() {
      this.tomorrow = (Date.parse(new Date().toDateString()) + 86400000);
      const tomorrowIsoString = new Date(this.tomorrow).toISOString().split("T")[0];
      this.id = 'nhs_date';
      this.errorMessageId = 'nhs_ErrorForTourDateTime';
      this.errorCssClass = 'error';

      this.input = `<input id="${this.id}" data-qa="date-input" type="date" name="date"
      min="${tomorrowIsoString}" value="${tomorrowIsoString}"/>`;
      this.label = `<label for="${this.id}" class="date--label">Choose Date:</label>`;
      

      this.error = `<span id="${this.errorMessageId}" class="form__error" data-error-message=""
                      data-required-message="Please choose a preferred date" hidden>
                      Please choose a preferred date
                    </span>`;
    }
  
    getHtml() {
      return `<div class="flex--row align--center">
      ${this.label}${this.input}
      </div>
      ${this.error}`;
    }
  
    getNode() {
      return document.getElementById(this.id);
    }

    setInvalidState() {
        const errorMessage = document.getElementById(this.errorMessageId);
        const node = this.getNode();
    
        node.setAttribute('aria-invalid', true);
        node.classList.add(this.errorCssClass);
        errorMessage.removeAttribute('hidden');
    }
    
    setValidState() {
        const errorMessage = document.getElementById(this.errorMessageId);
        const node = this.getNode();
    
        node.removeAttribute('aria-invalid');
        node.classList.remove(this.errorCssClass);
        errorMessage.setAttribute('hidden', true);
    }

    isValid(node) {
      return (+new Date(`${node.value}T00:00`)) >= (+this.tomorrow);
    }

    validate() {
      return new Promise((resolve) => {
        const node = this.getNode();
        const isValid = this.isValid(node);
    
        if (isValid) {
          this.setValidState(node);
          resolve(true);
        } else {
          this.setInvalidState(node);
          resolve(false);
        }
      });
    }    
  }
  